import { buildLifeAreaGoalListTree } from '@griply/utils';
import { useSortedGoals } from 'features/goals';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TreeItem } from 'shared/components/ui/virtualized-tree-list';
import { useEntityLinks } from 'shared/hooks/use-entity-links';
import { Goal } from 'shared/types/goal';
import { ID } from 'shared/types/id';
import { LifeArea } from 'shared/types/life-area';

export type Options = {
  hideArchived?: boolean;
  hideCompleted?: boolean;
  goalChildrenByParentId?: Map<ID, ID[]>;
};

export const useLifeAreaGoalListTree = (
  goals: Goal[],
  lifeAreas: LifeArea[],
  { hideArchived, hideCompleted, goalChildrenByParentId }: Options,
) => {
  const { t } = useTranslation();
  // Rendered `goals` may exclude parent goals (e.g. projects); resolve life areas against the full set.
  const allGoals = useSortedGoals();
  const links = useEntityLinks();

  return useMemo<Record<ID, TreeItem>>(
    () =>
      buildLifeAreaGoalListTree(goals, lifeAreas, {
        hideArchived,
        hideCompleted,
        otherLifeAreaName: t('goals.no-life-area'),
        allGoals,
        links,
        goalChildrenByParentId,
      }),
    [
      goals,
      allGoals,
      lifeAreas,
      links,
      t,
      hideArchived,
      hideCompleted,
      goalChildrenByParentId,
    ],
  );
};
